import React, { useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";

let inativos = false;
export default function Lista({ history, location }) {
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    let params = { inativos: false };
    carregarLista(params);
  }, []);

  const carregarLista = (params) => {
    setCarregando(true);
    inativos = params.inativos;

    api
      .get("ciclos/listar", { exibirInativos: params.inativos })
      .then((res) => {
        setLista(res);
        setCarregando(false);
      });
  };

  const filtros = {
    title: "Filtrar",
    form: {
      inativos: {
        label: "Exibir inativos",
        type: "check",
        value: inativos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarLista,
    },
  };

  const abrirAcompanhamento = (registro) => {
    history.push(`/app/ciclo/${registro.id}`);
  };

  const tRegistros = {
    title: "Não iniciados",
    onLineClick: abrirAcompanhamento,
    newItemAction: () => history.push("/app/ciclo/0"),
    columns: [
      {
        label: "Nome",
        name: "nome",
        style: { fontWeight: "bolder" },
      },
      {
        label: "Ativo",
        name: "ativo",
        checkbox: true,
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={filtros} />

      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
